export default "__VITE_ASSET__BgO2ZiQB__"